import Vue from 'vue';
import jQuery from 'jquery';
import isMobile from '@/js/helpers/is-mobile';

const IS_MOBILE = isMobile();

Vue.directive('tooltip', {
    bind(element, {value = 0}) {
        if (IS_MOBILE) {
            return;
        }

        const delay = Number.isSafeInteger(value) ? value : 0;

        jQuery(element).tooltip({
            trigger: 'hover',
            container: 'body',
            delay: {show: delay, hide: 0},
        });
    },

    update(element, {value = 0}) {
        if (IS_MOBILE) {
            return;
        }

        const delay = Number.isSafeInteger(value) ? value : 0;

        const $element = jQuery(element);

        $element.tooltip('dispose');

        $element.tooltip({
            trigger: 'hover',
            container: 'body',
            delay: {show: delay, hide: 0},
        });
    },

    unbind(element) {
        if (IS_MOBILE) {
            return;
        }

        jQuery(element).tooltip('dispose');
    },
});
